export const headerVideo = 'background/header.mp4';
